import { spawn, call, takeLatest, put, all } from 'redux-saga/effects';

// Actions
import { ingresarAction } from '../../../../application/actions/ingresar';
import { loadersActions } from '../../../../application/actions/ui_loaders';
// import { logReqError } from '../../../ui/utils/functions';

import api from '../../../api';
const apiIngresar = api(process.env.REACT_APP_URL);

export function* fetchingresar(params) {
  try {
    const { rut , password, trackid } = params.payload;

    yield put(loadersActions.changeStatusLoader({ isLoading: true }));

    const body = {
      'rut': rut,
      'clave': password
    };  


    const { data } = yield call(apiIngresar.post,'persona/ingresar', body, {
      'Track-Id': trackid
    });

  
    yield put(loadersActions.changeStatusLoader({ isLoading: false }));

    if (data) {
      yield put(ingresarAction.fetchingresarSuccess({ respuestaServicio: data }));
    } else {
      yield put(ingresarAction.fetchingresarError());

    }

  } catch {
      //Errores
    yield all([
      put(ingresarAction.fetchingresarError())
    ]);
  }
}

export function* watchFetchIngresar() {
  yield takeLatest(ingresarAction.fetchingresar.type, fetchingresar);
}

export default function* rootSaga() {
  yield spawn(watchFetchIngresar);
}
